import React from 'react'
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import { Booklet, Team } from '../../../../types/generated.types'

// Configure dayjs to use ISO week
dayjs.extend(isoWeek);

// Component to display payment week
const PaymentWeekInfo: React.FC<{ salesEndDate: string | null | undefined }> = ({ salesEndDate }) => {
  const getPaymentWeek = (): string => {
    if (!salesEndDate) {
      return 'Under vecka 29';
    }

    const endDate = dayjs(salesEndDate);
    const paymentDate = endDate.add(2, 'week');
    const paymentWeek = paymentDate.isoWeek();

    return `Under vecka ${paymentWeek}`;
  };

  return <p>{getPaymentWeek()}.</p>;
};

interface TeamPayoffProps {
  team: Team
  selectedBooklet?: Booklet
}

const TeamPayoff: React.FC<TeamPayoffProps> = ({ team, selectedBooklet }) => {
  const isUsingAssociationBankInformation = team?.useAssociationPaymentInfo;
  const clearingNumber = team?.bankInformation?.clearingNumber || '-';
  const accountNumber = team?.bankInformation?.accountNumber || '-';

  // Förtjänst per sålt häfte
  const totalCommission = selectedBooklet?.totalCommission || 0;
  const supportCommissionToMainAssociation = selectedBooklet?.supportCommissionToMainAssociation || 0;
  // Lagets förtjänst = totalCommission minus stödandel till huvudförening (om det finns)
  const teamEarningsPerBooklet = totalCommission - supportCommissionToMainAssociation;

  return (
    <div className="team-payoff container flex justify-center mb-lg">
      <div className="box md flex flex-col gap-2">
        <h3>Förtjänst och utbetalning</h3>
        <div className="flex flex-col gap-2">
          <div>
            <strong>Förtjänst</strong>
            <p>{teamEarningsPerBooklet} kr per sålt häfte.</p>
          </div>
          <div>
            <strong>Utbetalning sker</strong>
            <PaymentWeekInfo salesEndDate={team?.salesEndDate} />
          </div>
          <div>
            <strong>Bankkonto</strong>
            {isUsingAssociationBankInformation ? (
              <p>Utbetalning sker till föreningens konto.</p>
            ) : (
              <>
                <p>Clearingnummer: {clearingNumber}</p>
                <p>Kontonummer: {accountNumber}</p>
              </>
            )}
          </div>
          <div>
            <p>Har du frågor kring säljperiod eller konto,<br />kontakta oss på info@mitthafte.se</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TeamPayoff
